import { render, staticRenderFns } from "./ReviewsAccolades.vue?vue&type=template&id=422afba4&"
import script from "./ReviewsAccolades.vue?vue&type=script&lang=js&"
export * from "./ReviewsAccolades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports